import Text from 'components/common/Text';

const MealCard = ({ meal }) => {
  return (
    <div className="mb-2 mr-2">
      <article className="min-h-full rounded-sm shadow-md">
        <div className="bg-white relative">
          <img className="min-h-full w-full rounded-t-sm" alt={meal.title} src={meal.photo} />
        </div>
        <div className="h-full flex-grow px-2 pb-4 pt-2 text-left">
          <Text className="textSm font-medium text-charcoal-100">{meal.title}</Text>
          <Text className="textSm text-charcoal-100">{meal.subtitle}</Text>
        </div>
      </article>
    </div>
  );
};

MealCard.propTypes = {
  meal: PropTypes.object,
};

export default MealCard;
